import React from "react";
import "./ProgressBar.scss";

interface ProgressBarProps {
  value?: number;
  max?: number;
  style?: React.CSSProperties;
  width?: string | number;
  height?: number | string; // MUI default is 4
  color?: string; // MUI default is "#1976d2"
  showPercent?: boolean;
  label?: string;
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max = 100,
  style,
  width = "100%",
  height = 4,
  color = "#1976d2",
  label,
  className,
}) => {
  const determinate =
    typeof value === "number" && typeof max === "number" && max > 0;
  const percent = determinate
    ? Math.round(((value as number) / (max as number)) * 100)
    : undefined;
  const isIndeterminate = !determinate;

  const wrapperClassName = ["ProgressBar", className].filter(Boolean).join(" ");

  return (
    <div style={{ width, ...style }} className={wrapperClassName}>
      <div
        className="ProgressBar__track"
        style={{
          height,
          borderRadius: height,
        }}
      >
        <div
          className={
            "ProgressBar__bar" +
            (isIndeterminate ? " ProgressBar__bar--indeterminate" : "")
          }
          style={{
            width: determinate ? `${percent}%` : undefined,
            background: color,
            borderRadius: height,
          }}
        />
      </div>
      {label && <div className="ProgressBar__label">{label}</div>}
    </div>
  );
};

